import { Link } from 'react-router-dom';
import {
  NO_INFO,
  getInitials,
  handleValidDate,
  handleValidTime
} from '../../../helpers/helpers';
import { KycVerificationStatusEnum } from './types';

const renderProfileImage = (name: string, surname: string, image: string) => {
  const fullName = `${name} ${surname}`;

  if (image) {
    return <img src={image} className='rounded-circle avatar-xs' />;
  } else {
    return (
      <div className='avatar-xs '>
        <div className='avatar-title rounded-circle'>
          {getInitials(fullName || NO_INFO)}
        </div>
      </div>
    );
  }
};

export const columns = [
  {
    id: 1,
    Header: 'User ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return <Link to={`/users/${cell?.value}`}>{cell?.value}</Link>;
    }
  },

  {
    id: 2,
    Header: 'Name',
    Cell: (cell: any) => {
      return (
        <div className='d-flex align-items-center gap-2'>
          {renderProfileImage(
            cell.row.original.name,
            cell.row.original.surname,
            cell.row.original.profileImageUrl
          )}
          {cell.row.original.name} {cell.row.original.surname}
        </div>
      );
    }
  },
  {
    id: 3,
    Header: 'Email',
    accessor: 'email',
    Cell: (cell: any) => {
      return cell.value || NO_INFO;
    }
  },

  {
    id: 4,
    Header: 'Username',
    Cell: (cell: any) => {
      return cell.row.original.username || NO_INFO;
    }
  },
  {
    id: 5,
    Header: 'Rank',
    Cell: (cell: any) => {
      return cell?.row?.original?.packageRank?.name || NO_INFO;
    }
  },
  {
    id: 6,
    Header: 'Sponsor UID',
    accessor: 'referrerId',
    Cell: (cell: any) => {
      return cell?.value || NO_INFO;
    }
  },
  {
    id: 7,
    Header: 'Sponsor Name',
    accessor: 'sponsorName',
    Cell: (cell: any) => {
      return cell?.value || NO_INFO;
    }
  },
  {
    id: 8,
    Header: 'SumSub Status',
    accessor: 'sumsubStatus',
    Cell: (cell: any) => {
      switch (cell.value) {
        case KycVerificationStatusEnum.NOT_STARTED:
          return (
            <div
              style={{
                display: 'inline-block',
                color: '#9CA3AF',
                backgroundColor: 'rgba(33, 37, 41, 0.1)',
                borderRadius: 3,
                fontSize: '0.75em',
                padding: '0 0.65em',
                fontWeight: 600
              }}>
              {' '}
              NOT STARTED
            </div>
          );

        case KycVerificationStatusEnum.PENDING:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              {cell.value}
            </span>
          );

        case KycVerificationStatusEnum.VERIFIED:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              {cell.value}
            </span>
          );

        case KycVerificationStatusEnum.REJECTED:
          return (
            <span className='badge text-uppercase  badge-soft-danger'>
              {cell.value}
            </span>
          );
      }
    }
  },

  {
    id: 9,
    Header: 'Date',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell.value)},
        <small className='text-muted'> {handleValidTime(cell.value)}</small>
      </>
    )
  },
  {
    id: 10,
    Header: 'Structure Side',
    accessor: 'structureSide',
    Cell: (cell: any) =>
      cell.value
        ? cell.value.charAt(0).toUpperCase() + cell.value.slice(1)
        : NO_INFO
  }
];
